import axios from 'axios'
import {
  OpticalFormFinalizePayload,
  OpticalFormFinalizeResponse,
  OpticalFormProcessResponse,
  OpticalFormExamResult,
  OpticalQuestionReviewRequestPayload,
  OpticalQuestionReviewResponse,
  ExamBookletMappingResponse,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const CUSTOM_URL = `${API_URL}/Custom`

export const getExamPeriods = async () => {
  const response = await axios.get(`${CUSTOM_URL}/GetExamPeriods`)
  return Array.isArray(response.data) ? response.data : []
}

export const getExamsByPeriod = async (examPeriodId: number) => {
  const response = await axios.get(`${CUSTOM_URL}/GetExams`, {
    params: {examPeriodId},
  })
  if (Array.isArray(response.data)) {
    return response.data
  }
  if (Array.isArray(response.data?.data)) {
    return response.data.data
  }
  return []
}

export const processOpticalForms = async (formData: FormData): Promise<OpticalFormProcessResponse> => {
  const response = await axios.post(`${CUSTOM_URL}/ProcessOpticalForms`, formData, {
    headers: {'Content-Type': 'multipart/form-data'},
  })
  return response.data as OpticalFormProcessResponse
}

export const finalizeOpticalForms = async (
  payload: OpticalFormFinalizePayload
): Promise<OpticalFormFinalizeResponse> => {
  const response = await axios.post(`${CUSTOM_URL}/FinalizeOpticalForms`, payload)
  return response.data as OpticalFormFinalizeResponse
}

export const saveOpticalExamResult = async (
  examPeriodId: number,
  exam: OpticalFormExamResult
) => {
  const response = await axios.post(`${CUSTOM_URL}/SaveOpticalExamResult`, {
    examPeriodId,
    exam,
  })
  return response.data
}

export const getOpticalQuestionReview = async (
  payload: OpticalQuestionReviewRequestPayload
): Promise<OpticalQuestionReviewResponse> => {
  const response = await axios.post(
    `${CUSTOM_URL}/GetOpticalQuestionReview`,
    payload
  )
  return response.data as OpticalQuestionReviewResponse
}

export const importExamBookletMappings = async (
  examId: number,
  file: File
): Promise<ExamBookletMappingResponse> => {
  const formData = new FormData()
  formData.append('examId', String(examId))
  formData.append('file', file)

  const response = await axios.post(`${CUSTOM_URL}/ImportExamBookletMappings`, formData, {
    headers: {'Content-Type': 'multipart/form-data'},
  })

  if (response?.data?.data) {
    return response.data.data as ExamBookletMappingResponse
  }

  return response.data as ExamBookletMappingResponse
}

export const updateExamBookletMappings = async (
  examId: number,
  bookletQuestionOrder: Record<string, number[]>,
  optionOrderByBooklet: Record<number, Record<string, number[]>>
): Promise<ExamBookletMappingResponse> => {
  const response = await axios.post(`${CUSTOM_URL}/UpdateExamBookletMappings`, {
    examId,
    bookletQuestionOrder,
    optionOrderByBooklet,
  })

  if (response?.data?.data) {
    return response.data.data as ExamBookletMappingResponse
  }

  return response.data as ExamBookletMappingResponse
}
